import React, { forwardRef, useRef } from 'react'
import { BaseService } from '../../services/BaseService'
import Cookies from 'js-cookie'
import { useLocation, matchPath } from 'react-router-dom'

const AutoCapture = forwardRef(({ moduleId, ...props }, ref) => {
  const streamRef = useRef(null)
  const intervalRef = useRef(null)
  const videoRef = useRef(null)
  // const captureCountRef = useRef(0)
  const KEY = 'camera_capture_log'

  const location = useLocation()

  const isQuestionPage = matchPath({ path: '/question/:id' }, location.pathname)

  const currentModuleId = useRef(moduleId)
  // console.log({ moduleId })

  React.useEffect(() => {
    currentModuleId.current = moduleId
  }, [moduleId])

  React.useEffect(() => {
    if (!isQuestionPage) {
      console.log('🛑 Route berubah, stop kamera')
      stopCamera()
    }
    // eslint-disable-next-line
  }, [isQuestionPage])

  // const startCamera = async () => {
  //   if (!currentModuleId.current) {
  //     console.warn(`[${getTimeNow()}] ❌ Skip upload — id_modul belum valid.`)
  //     stopCamera()
  //     return
  //   }

  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true })
  //     streamRef.current = stream

  //     const video = document.createElement('video')
  //     video.srcObject = stream
  //     video.play()
  //     videoRef.current = video

  //     video.onloadedmetadata = () => {
  //       // console.log(`[${getTimeNow()}] Kamera siap, mulai capture...`)

  //       // langsung capture pertama
  //       capturePhoto(video)

  //       // interval capture
  //       intervalRef.current = setInterval(() => {
  //         // console.log(`[${getTimeNow()}] Interval trigger capture`)
  //         capturePhoto(video)
  //       }, process.env.REACT_APP_AUTO_CAPTURE_INTERVAL || 600000) // callback tiap 10 menit
  //     }
  //   } catch (err) {
  //     console.error('Gagal akses kamera:', err)
  //   }
  // }

  const startCamera = async () => {
    try {
      if (streamRef.current) {
        console.warn('🎥 Kamera sudah aktif.')
        return
      }

      console.log('🎥 Meminta izin kamera...')
      const stream = await navigator.mediaDevices.getUserMedia({ video: true })
      streamRef.current = stream

      if (videoRef.current) {
        videoRef.current.srcObject = stream
        videoRef.current
          .play()
          .then(() => console.log('🎥 Video.play() sukses'))
          .catch((err) => console.error(`❌ Video.play() error: ${err.message}`))
      }
    } catch (err) {
      console.error(`❌ startCamera gagal: ${err.message}`)
    }
  }

  // const stopCamera = () => {
  //   // console.log(`[${getTimeNow()}] Stop kamera & interval capture dihentikan`)
  //   clearInterval(intervalRef.current)
  //   streamRef.current?.getTracks().forEach((t) => t.stop())
  // }

  const stopCamera = () => {
    if (streamRef.current) {
      console.log('🛑 Menghentikan kamera...')
      streamRef.current.getTracks().forEach((t) => t.stop())
      streamRef.current = null
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null
    }
  }

  React.useEffect(() => {
    return () => {
      if (!isQuestionPage) {
        console.log('🛑 Auto stop kamera (unmount)')
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((t) => t.stop())
          streamRef.current = null
        }
      }
    }
    // eslint-disable-next-line
  }, [])

  // const saveCaptureStatus = (questionNumber, status) => {
  //   const existing = JSON.parse(localStorage.getItem(KEY) || '{}')

  //   const expected = existing.expected || []
  //   const success = existing.success || []
  //   const failed = existing.failed || []

  //   if (status === 'success') {
  //     if (!success.includes(questionNumber)) success.push(questionNumber)

  //     // kalau sebelumnya gagal → hapus
  //     const idx = failed.indexOf(questionNumber)
  //     if (idx !== -1) failed.splice(idx, 1)
  //   }

  //   if (status === 'failed') {
  //     if (!failed.includes(questionNumber)) failed.push(questionNumber)
  //   }

  //   localStorage.setItem(KEY, JSON.stringify({ expected, success, failed }))
  // }

  const saveCaptureStatus = (key, status) => {
    const data = JSON.parse(localStorage.getItem(KEY) || '{}')

    data[key] = status

    localStorage.setItem(KEY, JSON.stringify(data))
    // alert('LOG: ', JSON.stringify(data))
  }

  const capturePhoto = (video, questionNumber) => {
    if (!video || !video.videoWidth || !video.videoHeight) {
      console.warn(`⚠️ Video belum siap unit soal ${questionNumber}`)
      saveCaptureStatus(questionNumber, 'failed')
      return Promise.resolve('failed')
    }

    return new Promise((resolve) => {
      const canvas = document.createElement('canvas')
      const MAX_WIDTH = 400
      const scale = Math.min(1, MAX_WIDTH / video.videoWidth)
      canvas.width = video.videoWidth * scale
      canvas.height = video.videoHeight * scale

      const ctx = canvas.getContext('2d')
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

      console.log(`📸 Mengambil foto soal ${questionNumber} (${canvas.width}x${canvas.height})...`)

      canvas.toBlob(
        async (blob) => {
          if (!blob) {
            console.error('❌ Blob kosong!')
            saveCaptureStatus(questionNumber, 'failed')
            resolve('failed')
            return
          }

          const base64String = canvas.toDataURL('image/jpeg', 0.5)
          const userCookie = Cookies.get('user')
          let userId = null
          if (userCookie) {
            try {
              userId = JSON.parse(atob(userCookie))?.id
            } catch (e) {
              console.error(`❌ Parse cookie gagal: ${e.message}`)
            }
          }

          if (!userId) {
            console.error('❌ userId TIDAK ADA di cookie!')
            saveCaptureStatus(questionNumber, 'failed')
            resolve('failed')
            return
          }

          const status = await uploadPhotoBase64(base64String, userId, questionNumber)
          resolve(status)
        },
        'image/jpeg',
        0.5,
      )
    })
  }

  const uploadPhotoBase64 = async (base64String, userId, questionNumber) => {
    if (!currentModuleId.current) {
      console.error('❌ moduleId NULL, skip upload.')
      saveCaptureStatus(questionNumber, 'failed')
      return 'failed'
    }

    try {
      const encoded = encodeURIComponent(base64String)
      const payload = {
        keterangan: `capture_${questionNumber}`,
        id_modul: currentModuleId.current,
        id_user: userId,
        url: encoded,
      }

      console.log(`📤 Menghubungi backend /m_user_capture...`)
      const service = new BaseService('/m_user_capture')
      const response = await service.postPictureCaptured(payload)

      if (response && response.status >= 200 && response.status < 300) {
        console.log(`✅ Backend success (Status: ${response.status})`)
        saveCaptureStatus(questionNumber, 'success')
        return 'success'
      } else {
        console.warn(`⚠️ Backend error: ${response?.status}`)
        saveCaptureStatus(questionNumber, 'failed')
        return 'failed'
      }
    } catch (err) {
      console.error(`❌ Upload fatal: ${err.message}`)
      saveCaptureStatus(questionNumber, 'failed')
      return 'failed'
    }
  }

  // Helper buat log waktu real-time
  // const getTimeNow = () => {
  //   const now = new Date()
  //   return now.toLocaleTimeString('id-ID', { hour12: false })
  // }

  // NEW MECHANISM, capture once
  const captureOnce = async (questionNumber) => {
    if (!isQuestionPage) {
      console.warn(`🚫 Blok capture (bukan question page)`)
      return 'failed'
    }
    if (!videoRef.current) {
      console.warn(`🚫 Blok capture (video ref NULL)`)
      return 'failed'
    }
    return await capturePhoto(videoRef.current, questionNumber)
  }

  React.useImperativeHandle(ref, () => ({
    startCamera,
    stopCamera,
    captureOnce,
  }))

  return (
    <video
      ref={videoRef}
      style={{
        position: 'fixed',
        top: '-1000px',
        left: '-1000px',
        width: '1px',
        height: '1px',
        opacity: 0,
        pointerEvents: 'none',
        zIndex: -1,
      }}
      playsInline
      muted
      autoPlay
    />
  )
})

export default AutoCapture
